import { Navigate, Outlet } from "react-router-dom";
// import { useAuth } from "./authContext"; // Adjust the import based on your authentication context

const ProtectedRoute = () => {
	// const { isAuthenticated } = useAuth(); // Check if user is authenticated

	return localStorage.getItem("@jwt") ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
